// hooks/useStudentGroups.js
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSnackError } from '../Reducers/snackErrors';
import { tutorService } from '../Services/tutorService';

export const useGetTutorShift = () => {
  const [schedule, setSchedule] = useState([]);
  const [sessionCount, setSessionCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const fetchTutorSchedule = async () => {
    
    setLoading(true);
    try {
      const data = await tutorService.getScheduleShift();
      setSchedule(data);
      setSessionCount(data ? Object.keys(data).sort().length : 0);
      return data;
    } catch (error) {
      if (error.isAuthError || error.isForbidden) {
        return null;
      }
      if (error.isNetworkError) {
        dispatch(setSnackError({ 
          title: 'Connection Error', 
          body: error.message 
        }));
      } else {
        dispatch(setSnackError({
          title: 'Error found',
          body: error.message || 'Unable to get students.'
        }));
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { 
    schedule, 
    loading,
    sessionCount,
    fetchTutorSchedule 
  };
};